import { registerSW } from 'virtual:pwa-register';
import { PWA_LIFECYCLE_EVENT, type PwaLifecycleDetail } from './lifecycle';

export { PWA_LIFECYCLE_EVENT, type PwaLifecycleDetail } from './lifecycle';

function announce(detail: PwaLifecycleDetail): void {
  window.dispatchEvent(new CustomEvent<PwaLifecycleDetail>(PWA_LIFECYCLE_EVENT, { detail }));
}

/** Registers the offline layer while leaving activation and reload user initiated. */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  let hasControlledPage = navigator.serviceWorker.controller !== null;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hasControlledPage) {
      announce({ phase: 'reload-required' });
    }
    // The first claim makes the app offline-ready but does not replace an
    // already-running generation, so only later controller changes need reload.
    hasControlledPage = true;
  });

  const updateServiceWorker = registerSW({
    onOfflineReady() {
      announce({ phase: 'offline-ready' });
    },
    onNeedRefresh() {
      announce({
        phase: 'update-ready',
        activate: () => {
          hasControlledPage = true;
          return updateServiceWorker(false);
        },
      });
    },
    // Supplying this callback prevents vite-plugin-pwa from reloading the page
    // automatically after the waiting worker takes control.
    onNeedReload() {
      announce({ phase: 'reload-required' });
    },
  });
}
